import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, useLocation, Navigate, matchPath } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import ProtectedRoute from './ProtectedRoute';
import { ROUTE_ENUM } from './RoutesConstant';
import { Outlet } from 'react-router-dom';

function TitleSetter() {
  const location = useLocation();
  useEffect(() => {
    const matched = Object.values(ROUTE_ENUM).find((route) =>
      matchPath({ path: route.routePath, end: true }, location.pathname)
    );
    if (matched?.title) document.title = matched.title;
  }, [location]);
  return null;
}

const ProtectedRouteComponent = (Component, skipProtection = false) => {
  return (
    <ProtectedRoute skipProtection={skipProtection}>
      {React.createElement(Component)}
    </ProtectedRoute>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <LayoutWithTitleSetter />,
    children: [
      {
        path: ROUTE_ENUM.ROOT.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.ROOT.component.type),
      },
      {
        path: ROUTE_ENUM.AUTH_LOGIN.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.AUTH_LOGIN.component.type),
      },
      {
        path: ROUTE_ENUM.AUTH_OTP.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.AUTH_OTP.component.type, true),
      },
      {
        path: ROUTE_ENUM.SELECT_GAME.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.SELECT_GAME.component.type),
      },
      {
        path: '/Notifications',
        element: <Navigate to={ROUTE_ENUM.SELECT_GAME.routePath} replace />,
      },
      {
        path: ROUTE_ENUM.SELECT_RAP_HOUSIE_GAME.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.SELECT_RAP_HOUSIE_GAME.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_HOUSIE_WAITING.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_HOUSIE_WAITING.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_HOUSIE_LEADERBOARD.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_HOUSIE_LEADERBOARD.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_HOUSIE_GAME_LIVE.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_HOUSIE_GAME_LIVE.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_HOUSIE_ROOM_TYPE.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_HOUSIE_ROOM_TYPE.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_HOUSIE_ROOM_NAME.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_HOUSIE_ROOM_NAME.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_HOUSIE_ROOM_CODE_SHARE_START_GAME.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_HOUSIE_ROOM_CODE_SHARE_START_GAME.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_HOUSIE_JOIN_ANOTHER_ROOM.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_HOUSIE_JOIN_ANOTHER_ROOM.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_GAME.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_FIRE_GAME.component.type),
      },
      {
        path: ROUTE_ENUM.SELECT_RAP_FIRE_GAME.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.SELECT_RAP_FIRE_GAME.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_ROOM_TYPE.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_FIRE_ROOM_TYPE.component.type, true),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_ROOM_CODE_SHARE_START_GAME.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_FIRE_ROOM_CODE_SHARE_START_GAME.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_JOIN_ANOTHER_ROOM.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_FIRE_JOIN_ANOTHER_ROOM.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_WAITING.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_FIRE_WAITING.component.type),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_LEADERBOARD.routePath,
        element: ProtectedRouteComponent(ROUTE_ENUM.RAP_FIRE_LEADERBOARD.component.type),
      },
      {
        path: ROUTE_ENUM.TOURNAMENT_LEADERBOARD.routePath,
        element: ProtectedRouteComponent(
          ROUTE_ENUM.TOURNAMENT_LEADERBOARD.component.type,
          true
        ),
      },
      {
        path: ROUTE_ENUM.LEADERBOARD_DESIGN_PREVIEW.routePath,
        element: ProtectedRouteComponent(
          ROUTE_ENUM.LEADERBOARD_DESIGN_PREVIEW.component.type,
          true
        ),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_LEADERBOARD_DESIGN_PREVIEW.routePath,
        element: ProtectedRouteComponent(
          ROUTE_ENUM.RAP_FIRE_LEADERBOARD_DESIGN_PREVIEW.component.type,
          true
        ),
      },
      {
        path: ROUTE_ENUM.RAP_FIRE_GAME_DESIGN_PREVIEW.routePath,
        element: ProtectedRouteComponent(
          ROUTE_ENUM.RAP_FIRE_GAME_DESIGN_PREVIEW.component.type,
          true
        ),
      },
      {
        path: ROUTE_ENUM.TOURNAMENT_LEADERBOARD_DESIGN_PREVIEW.routePath,
        element: ProtectedRouteComponent(
          ROUTE_ENUM.TOURNAMENT_LEADERBOARD_DESIGN_PREVIEW.component.type,
          true
        ),
      },
    ],
  },
]);


function LayoutWithTitleSetter() {
  return (
    <>
      <TitleSetter />
      {/* Render child routes */}
      <React.Suspense>
        <Outlet />
      </React.Suspense>
    </>
  );
}

export default function AppRoutes() {
  return (
    <Authenticator.Provider>
      <RouterProvider
        router={router}
        future={{ v7_startTransition: true }}
      />
    </Authenticator.Provider>
  );
}
